import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { alpha } from '@mui/material';

const InfoWrapper = styled('li')(
  ({ theme }) => ({
    marginTop: -8,
    marginBottom: 8,
    padding: '8px 16px',
    color: theme.palette.text.primary,
    backgroundColor: alpha(theme.palette.primary.main, 0.15),
    display: 'flex',
    alignItems: 'center',
    '.MuiSvgIcon-root': {
      marginRight: 12,
      color: theme.palette.primary.main,
    },
    span: {
      marginLeft: 4,
      fontWeight: 700,
      maxWidth: 150,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    backgroundColor: 'transparent',
    borderBottom: `1px solid ${theme.palette.divider}`,
  })),
);

export default InfoWrapper;
